import type {
  OrderFilters,
  OrderFromErpFilters,
  OrderFromTmsFilters,
  OrderShortStatus,
} from '@models/order'
import { keyToUrl } from '@tools/common'
import { omit } from 'lodash'

export const ordersKeys = {
  root: ['orders'] as const,
  orders: (filters?: OrderFilters) =>
    [
      ...ordersKeys.root,
      omit(filters, ['page', 'limit']),
      { page: filters?.page, limit: filters?.limit },
    ] as const,
  tmsOrders: (filters?: OrderFromTmsFilters) =>
    [
      ...ordersKeys.root,
      'tms',
      omit(filters, ['page', 'limit']),
      { page: filters?.page, limit: filters?.limit },
    ] as const,
  erpOrders: (filters?: OrderFromErpFilters) =>
    [
      ...ordersKeys.root,
      'erp',
      omit(filters, ['page', 'limit']),
      { page: filters?.page, limit: filters?.limit },
    ] as const,
  orderExport: (filters?: Omit<OrderFilters, 'page' | 'limit'>) =>
    [...ordersKeys.root, 'export', filters] as const,
  order: (id: number) => [...ordersKeys.root, id] as const,
  actions: () => [...ordersKeys.root, 'actions'] as const,
  cancelOrder: (id: number) => [...ordersKeys.root, id, 'cancel'] as const,
  acceptWaresToDepot: () =>
    [...ordersKeys.actions(), 'acceptWaresToDepot'] as const,
  orderGoodsDeliveryNote: (id: number) =>
    [...ordersKeys.root, id, 'goodsDeliveryNote'] as const,
  orderPackagingReturnReport: (id: number) =>
    [...ordersKeys.root, id, 'packagingReturnReport'] as const,
  bulkAcceptOrder: () =>
    [...ordersKeys.root, 'actions', 'bulkAcceptOrder'] as const,
  finishStop: () => [...ordersKeys.root, 'actions', 'finishStop'] as const,
}

export const ordersUrls = {
  root: keyToUrl(ordersKeys.root),
  ordersExport: keyToUrl(ordersKeys.orderExport()),
  orders: () => keyToUrl(ordersKeys.orders()),
  erpOrders: keyToUrl(ordersKeys.erpOrders()),
  tmsOrders: keyToUrl(ordersKeys.tmsOrders()),
  order: (id: number) => keyToUrl(ordersKeys.order(id)),
  acceptWaresToDepot: keyToUrl(ordersKeys.acceptWaresToDepot()),
  cancelOrder: (id: number) => keyToUrl(ordersKeys.cancelOrder(id)),
  orderGoodsDeliveryNote: (id: number) =>
    keyToUrl(ordersKeys.orderGoodsDeliveryNote(id)),
  orderPackagingReturnReport: (id: number) =>
    keyToUrl(ordersKeys.orderPackagingReturnReport(id)),
  bulkAcceptOrder: keyToUrl(ordersKeys.bulkAcceptOrder()),
  finishStop: keyToUrl(ordersKeys.finishStop()),
}

export const ORDER_SHORT_STATUSES: Readonly<OrderShortStatus[]> = [
  'NOT_PROCESSED',
  'DELIVERY',
  'NOT_ACCEPTED',
  'DELIVERED',
  'NOT_DELIVERED',
  'CANCELED',
]
